import { KeyboardArrowDown } from '@mui/icons-material';
import {
  Avatar,
  Box,
  Button,
  Divider,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
import { useDisclose } from 'basic-react-hooks';
import { LightningIcon, UserProfileIcon } from 'components/Icons';
import ModalSignInPin from 'components/Modal/ModalSignInPin';
import { getAuth } from 'firebase/auth';
import useShallowEqualSelector from 'hooks/useShallowEqualSelector';
import { app } from 'pages/DeleteUser/firebase';
import { useMainContext } from 'pages/PublicPage/Layout';
import AccountSettings from 'pages/PublicPage/VerifyCertificateSubscriptions/AccountSettings';
import ModalManageSubscriptions from 'pages/PublicPage/VerifyCertificateSubscriptions/ModalManageSubscriptions';
import React from 'react';
import { useDispatch } from 'react-redux';
import { logoutPublicUser } from 'redux/reducers/publicUser';
import { show } from 'redux/reducers/snackbar';

const ITEMS = [
  {
    text: 'Profile',
    Icon: UserProfileIcon,
    key: 'profile',
  },
  {
    text: 'Manage Subscriptions',
    Icon: LightningIcon,
    key: 'subscription',
  },
];

const auth = getAuth(app);

const AccountProfile = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const publicUser = useShallowEqualSelector((state) => state.publicUser);
  const open = Boolean(anchorEl);
  const dispatch = useDispatch();
  const { isOpenLogin, onOpenLogin, onCloseLogin } = useMainContext();
  const {
    isOpen: isOpenProfile,
    onOpen: onOpenProfile,
    onClose: onCloseProfile,
  } = useDisclose();
  const {
    isOpen: isOpenSubscription,
    onOpen: onOpenSubscription,
    onClose: onCloseSubscription,
  } = useDisclose();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const onClickLogout = () => {
    auth.signOut();
    handleClose();
    dispatch(show({ message: 'Logout successfully', severity: 'success' }));
    dispatch(logoutPublicUser());
  };

  const onClick = (item) => {
    switch (item.key) {
      case 'profile':
        onOpenProfile();
        break;
      case 'subscription':
        onOpenSubscription();
        break;
      default:
    }

    handleClose();
  };

  return (
    <>
      {publicUser.isLogin ? (
        <Button
          sx={{
            py: '2px',
            bgcolor: 'rgba(255, 255, 255, 0.2)',
            ml: 2,
            borderRadius: '32px',
            pl: '2px',
          }}
          onClick={handleClick}
        >
          <Avatar src={publicUser.user.avatar}>{publicUser.user?.name}</Avatar>
          <KeyboardArrowDown
            color="white"
            sx={{
              color: 'white',
              ml: '6px',
            }}
          />
        </Button>
      ) : (
        <Button
          onClick={onOpenLogin}
          sx={{
            color: 'black',
            bgcolor: 'white',
            borderRadius: '32px',
            px: '20px',
            py: '10px',
            '&:hover': {
              bgcolor: 'rgba(255, 255, 255, 0.8)',
            },
          }}
        >
          Login
        </Button>
      )}
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            sx: {
              borderRadius: '12px',
              maxWidth: '300px',
              width: '100%',
            },
          },
        }}
      >
        <Box display={'flex'} px={'16px'} gap={'8px'} pb={'16px'} pt={'8px'}>
          <Avatar src={publicUser?.user?.avatar}>
            {publicUser?.user?.fullName}
          </Avatar>
          <Box>
            <Typography fontSize={16} fontWeight={600}>
              {publicUser?.user?.fullName}
            </Typography>
            <Typography>{publicUser?.user?.phoneNumber}</Typography>
          </Box>
        </Box>
        <Divider />
        <Box
          px={'8px'}
          py={'8px'}
          display={'flex'}
          flexDirection={'column'}
          gap={'8px'}
        >
          {ITEMS.map((i) => {
            return (
              <MenuItem
                key={i.key}
                onClick={() => onClick(i)}
                sx={{
                  gap: '12px',
                  borderRadius: '7px',
                  transition: 'all 0.3s',
                  '&:hover': {
                    bgcolor: 'rgba(94, 196, 172, 0.1)',
                  },
                  px: '8px',
                }}
              >
                <i.Icon color={'#4F4D55'} />
                {i.text}
              </MenuItem>
            );
          })}
        </Box>
        <Divider />
        <Box p={'16px'} pb={'4px'}>
          <Button
            variant="outlined"
            sx={{
              borderRadius: '8px',
              width: '100%',
              borderColor: 'rgba(230, 230, 230, 1)',
              color: 'rgba(79, 77, 85, 1)',
              fontWeight: 500,
              textTransform: 'none',
            }}
            onClick={onClickLogout}
          >
            Log out
          </Button>
        </Box>
      </Menu>
      <AccountSettings open={isOpenProfile} onClose={onCloseProfile} />
      <ModalManageSubscriptions
        open={isOpenSubscription}
        onClose={onCloseSubscription}
      />
      <ModalSignInPin open={isOpenLogin} onClose={onCloseLogin} />
    </>
  );
};

export default AccountProfile;
